@use '../../style/reset.scss';
@use '../../style/variables.scss';
@use '../../style/mixins.scss';
@use '../../style/functions.scss';
@use '../../style/typography.scss';
@use '../../style/global-layout-rules.scss';

:host {
    display: block;
}

.docs {
    kompendium-markdown {
        display: block;
        width: 100%;
        max-width: functions.pxToRem(960);
    }
}
